// Helper mínimo para leer el mensaje de error del backend sin `any` (constitution.md regla #5).
// Axios no tipa `error.response.data` de forma útil; aquí se estrecha `unknown` a la forma
// observada (siempre `.message`, spec.md §3/§4 en todo `enterprise`). Mismo patrón que
// `catalog`/`cloud`/`workforce` (cada módulo es dueño de su propio helper hasta que exista un
// tipo de error compartido en `shared/api/http.ts`, regla #4).

function apiErrorData(err: unknown): Record<string, unknown> | undefined {
  if (err && typeof err === 'object' && 'response' in err) {
    const data = (err as { response?: { data?: unknown } }).response?.data;
    if (data && typeof data === 'object') return data as Record<string, unknown>;
  }
  return undefined;
}

export function apiErrorMessage(err: unknown): string | undefined {
  const value = apiErrorData(err)?.message;
  return typeof value === 'string' ? value : undefined;
}
